"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

/**
 * Get the current state for the specified domain. If the domain is invalid, will retry after
 * 2 seconds, because the domain might be a newly created dynamic domain, which did not have time
 * to propagate between all servers.
 * @param {*} socket - The socket from which to emit
 * @param {*} domainName - The name of the domain
 * @param {*} isRetry - Whether or not the function has already tried
 */
function getCurrentState(socket, domainName) {
  var isRetry = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  return new Promise(function (resolve, reject) {
    socket.emit('getState', {
      domain: domainName
    }, function (_ref) {
      var state = _ref.state,
          errCode = _ref.errCode,
          errMessage = _ref.errMessage;

      if (errCode === 'INVALID_DOMAIN' && !isRetry) {
        return setTimeout( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
          return regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  _context.prev = 0;
                  _context.t0 = resolve;
                  _context.next = 4;
                  return getCurrentState(socket, domainName, true);

                case 4:
                  _context.t1 = _context.sent;
                  (0, _context.t0)(_context.t1);
                  _context.next = 11;
                  break;

                case 8:
                  _context.prev = 8;
                  _context.t2 = _context["catch"](0);
                  reject(_context.t2);

                case 11:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee, null, [[0, 8]]);
        })), 2000);
      } else if (errCode) {
        return reject(new Error(errMessage));
      }

      return resolve(state);
    });
  });
}

var _default = getCurrentState;
exports["default"] = _default;